import React from 'react';

const FormContainer = ({
  title,
  subtitle,
  children,
  className = '',
  ...props
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="bg-white py-8 px-6 shadow-lg rounded-lg">
          {title && (
            <div className="text-center mb-6">
              <h2 className="text-3xl font-bold text-gray-900 mb-2">
                {title}
              </h2>
              {subtitle && (
                <p className="text-sm text-gray-600">{subtitle}</p>
              )}
            </div>
          )}
          <div className={`text-left ${className}`} {...props}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormContainer; 